import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';

export class FreeDataScenario extends BasicScenario {
manageArgs: boolean | null;
manageHierarchy: boolean | null;
manageLevels: boolean | null;
manageValues: boolean | null;
}

